import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import Content from "../../../Components/Dashboard/Content/Content";
import Chartdelta from "../../../Utils/main/deltachart";
import { Get_All_Service_for_Client } from "../../../ReduxStore/Slice/Common/commoSlice";
import { useDispatch } from "react-redux";
import { TRADE_EXECUTE, GET_SERVICE_NAME } from "../../../Service/user.service";
import { GetSubadminStrategy } from "../../../Service/admin.service";


import { GET_ALL_COMPANY_INFO } from "../../../Service/subadmin.service"
import Swal from "sweetalert2";
import Select from "react-select";
import PositionModal from "./positions";
import {
  TrendingUp,
  TrendingDown,
  Activity,
  Target,
  AlertTriangle,
  DollarSign,
  BarChart3,
  Zap,
  Settings,
  RefreshCw,
  Shield,
  PieChart,
  Wifi,
  WifiOff,
  AlertCircle,
} from "lucide-react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { usePrices } from "../../../context/PriceContext";

const orderTypes = ["Long", "Short"];

// ✅ Memoized Error Alert Component
const ErrorAlert = React.memo(({ error, onDismiss }) => {
  if (!error) return null;
  return (
    <div className="alert alert-danger alert-dismissible fade show" role="alert">
      <AlertCircle size={16} className="me-2" />
      {error}
      {onDismiss && (
        <button type="button" className="btn-close" onClick={onDismiss} aria-label="Close" />
      )}
    </div>
  );
});

// ✅ Memoized Market Data Display Component
const MarketDataDisplay = React.memo(({ getPriceData, isInitialLoad, selectedSymbol }) => {
  if (!getPriceData || (Object.keys(getPriceData).length === 0 && isInitialLoad)) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mb-1 fw-semibold">Connecting to market data...</p>
        <small className="text-muted">{selectedSymbol}</small>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="d-flex justify-content-between align-items-center">
        <span>24h Change</span>
        <span className={`fw-semibold ${parseFloat(getPriceData.mark_change_24h) >= 0 ? "text-success" : "text-danger"}`}>
          {getPriceData.mark_change_24h}%
        </span>
      </div>

      <div className="d-flex justify-content-between align-items-center">
        <span>Volume</span>
        <span className="fw-semibold">{getPriceData.volume?.toLocaleString()}</span>
      </div>

      <div className="d-flex justify-content-between align-items-center">
        <span>High 24h</span>
        <span className="fw-semibold">${getPriceData.high}</span>
      </div>

      <div className="d-flex justify-content-between align-items-center">
        <span>Low 24h</span>
        <span className="fw-semibold">${getPriceData.low}</span>
      </div>

      {getPriceData.quotes && (
        <>
          <hr className="my-3" />
          <div className="d-flex justify-content-between align-items-center">
            <span>Best Bid</span>
            <span className="fw-semibold text-success">${getPriceData.quotes.best_bid}</span>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <span>Best Ask</span>
            <span className="fw-semibold text-danger">${getPriceData.quotes.best_ask}</span>
          </div>
        </>
      )}
    </div>
  );
});




function Trade() {
  const dispatch = useDispatch();
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const ClientKey = localStorage.getItem("client_key");
  const lastPriceRef = useRef(null);
  const prevSymbolRef = useRef(null);

  const [selectedSymbol, setSelectedSymbol] = useState("BTCUSD");
  const [strategy, setStrategy] = useState("");
  const [orderType, setOrderType] = useState(orderTypes[0]);
  const [merketType, setMarketType] = useState("MARKET");
  const [searchText, setSearchText] = useState("BTCUSD");
  const [filteredSymbols, setFilteredSymbols] = useState([]);
  const [AllStrategy, setAllStrategy] = useState({ loading: true, data: [] });

  const [price, setPrice] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [selectRow, setSelectRow] = useState({});
  const [getPriceData, setGetPriceData] = useState(null);
  const [quantity, setQuantity] = useState(100);
  const [stopLoss, setStopLoss] = useState("");
  const [takeProfit, setTakeProfit] = useState("");
  const [errors, setErrors] = useState({});
  const [isExecuting, setIsExecuting] = useState(false);
  const [socketConnected, setSocketConnected] = useState(false);
  const [limitPrice, setLimitPrice] = useState("");
  const [stopPrice, setStopPrice] = useState("");
  const [loadingStates, setLoadingStates] = useState({
    strategies: false,
    symbols: false,
    executing: false,
  });
  const [chartShow, setChartShow] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [companyList, setCompanyList] = useState([]);
  const isgotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const [isLoading, setIsLoading] = useState(true);

  const [originalData, setOriginalData] = useState([]);



  const [panel_key, setPanel_key] = useState("");
  const gotodashboard = JSON.parse(localStorage.getItem("user_details_goTo"));



  const prices = usePrices();


  useEffect(() => {
    const token = localStorage.getItem("token");

    const fetchCompany = async () => {
      try {
        const res = await GET_ALL_COMPANY_INFO(token);

        if (res?.status && Array.isArray(res.data)) {
          // 🔹 pura data state me
          setCompanyList(res.data);

          // 🔹 panel_key nikalna (example: first company)
          const key = res.data[0]?.panel_key;
          if (key) {
            setPanel_key(key);
          }
        }
      } catch (err) {
        console.error("Company fetch error:", err);
      }
    };

    fetchCompany();
  }, []);



  const data = async () => {
    setLoadingStates((prev) => ({ ...prev, strategies: true }));

    try {
      const payload = {
        page: "1",
        limit: "100",
        userid: isgotodashboard ? gotodashboard.user_id : user_details.user_id,
      };

      const response = await GetSubadminStrategy(payload);

      if (response?.status && Array.isArray(response.data)) {
        setAllStrategy({
          loading: false,
          data: response.data,
        });

        setOriginalData(response.data);

        // auto select first strategy
        setStrategy(response.data[0]?.strategy_name || "");
      } else {
        setAllStrategy({ loading: false, data: [] });
      }

    } catch (error) {
      console.error("Error fetching strategy:", error);
      setAllStrategy({ loading: false, data: [] });
    } finally {
      setLoadingStates((prev) => ({ ...prev, strategies: false }));
    }
  };



  useEffect(() => {
    // Symbol changed - reset state
    if (prevSymbolRef.current !== selectedSymbol) {
      setGetPriceData({});
      setSocketConnected(false);
      setIsInitialLoad(true);
      prevSymbolRef.current = selectedSymbol;
    }

    // Get latest price data from context
    const priceData = prices[selectedSymbol];

    if (priceData) {
      const newPrice = priceData?.spot_price;

      // Only update if price actually changed
      if (lastPriceRef.current !== newPrice) {
        lastPriceRef.current = newPrice;
        setPrice(newPrice);
        setGetPriceData(priceData);
        setSocketConnected(true);
        setIsInitialLoad(false);
      }
    }
  }, [selectedSymbol, prices]);

  // ✅ Optimized Validation with useMemo
  const validationErrors = useMemo(() => {
    const newErrors = {};

    if (!selectedSymbol) newErrors.symbol = "Please select a trading symbol";
    if (!strategy) newErrors.strategy = "Please select a trading strategy";
    if (!quantity || quantity <= 0) newErrors.quantity = "Quantity must be greater than 0";
    if (merketType === "LIMIT" && (!price || price < 0)) {
      newErrors.price = "Price must be greater than 0 for limit orders";
    }

    const basePrice = merketType === "LIMIT"
      ? parseFloat(limitPrice)
      : merketType === "STOP"
        ? parseFloat(stopPrice)
        : parseFloat(price);

    if (orderType === "Long") {
      if (stopLoss && parseFloat(stopLoss) >= basePrice) {
        newErrors.stopLoss = "Stop loss must be below the entry price";
      }
      if (takeProfit && parseFloat(takeProfit) <= basePrice) {
        newErrors.takeProfit = "Take profit must be above the entry price";
      }
    } else {
      if (stopLoss && parseFloat(stopLoss) <= basePrice) {
        newErrors.stopLoss = "Stop loss must be above the entry price for short orders";
      }
      if (takeProfit && parseFloat(takeProfit) >= basePrice) {
        newErrors.takeProfit = "Take profit must be below the entry price for short orders";
      }
    }

    return newErrors;
  }, [selectedSymbol, strategy, quantity, merketType, price, limitPrice, stopPrice, orderType, stopLoss, takeProfit]);

  // ✅ Sync validation errors
  useEffect(() => {
    setErrors(validationErrors);
  }, [validationErrors]);

  const validateForm = useCallback(() => {
    return Object.keys(validationErrors).length === 0;
  }, [validationErrors]);

  // ✅ Load strategies once on mount
  useEffect(() => {
    getAllStrategy();
  }, []);

  useEffect(() => {
    data();
  }, []);

  // ✅ Debounced symbol search
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchText.trim()) {
        getServiceName();
      }
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [searchText]);

  const getAllStrategy = async () => {
    setLoadingStates((prev) => ({ ...prev, strategies: true }));
    try {
      const response = await dispatch(
        Get_All_Service_for_Client({
          req: {},
          token: user_details.token,
        })
      ).unwrap();

      if (response.status) {
        setStrategy(response.data[0]?.strategy_name || "");
        setAllStrategy({ loading: false, data: response.data });
      }
    } catch (error) {
      console.error("Error loading strategies:", error);
    } finally {
      setLoadingStates((prev) => ({ ...prev, strategies: false }));
    }
  };

  const getServiceName = async () => {
    setLoadingStates((prev) => ({ ...prev, symbols: true }));
    try {
      const response = await GET_SERVICE_NAME({ name: searchText });
      if (response?.status) {
        setFilteredSymbols(response.data);
      }
    } catch (error) {
      console.error("Error loading symbols:", error);
    } finally {
      setLoadingStates((prev) => ({ ...prev, symbols: false }));
    }
  };

  const create = async ({ symbol, orderType }) => {
    if (!validateForm()) return;

    const newErrors = {};

    if (orderType === "Long" && merketType === "LIMIT" && limitPrice > price) {
      newErrors.limitPrice = "Limit price must be less than current price for Long orders";
      setErrors(newErrors);
      return;
    }

    if (orderType === "Short" && merketType === "LIMIT" && limitPrice < price) {
      newErrors.limitPrice = "Limit price must be greater than current price for Short orders";
      setErrors(newErrors);
      return;
    }

    if (orderType === "Short" && merketType === "STOP" && stopPrice > price) {
      newErrors.stopPrice = "Stop price must be less than current price for Short orders";
      setErrors(newErrors);
      return;
    }

    if (orderType === "Long" && merketType === "STOP" && stopPrice < price) {
      newErrors.stopPrice = "Stop price must be Greater than current price for Long orders";
      setErrors(newErrors);
      return;
    }

    let data = `symbol:${symbol}
|ordertype:${orderType === "Long" ? "BUY" : "SELL"}
|quantity:${quantity}
|price:${merketType === "LIMIT" ? limitPrice : merketType === "STOP" ? stopPrice : price}
|strategy:${strategy}  // <-- NOW WORKING
|key:${panel_key}
|category:Crypto
|signalType:${"PANEL_" + merketType}
|subadmin_id:${user_details?.user_id}`;

    if (stopLoss) data += `|sl:${stopLoss}`;
    if (takeProfit) data += `|target:${takeProfit}`;

    setIsExecuting(true);
    setLoadingStates((prev) => ({ ...prev, executing: true }));

    try {
      const Response = await TRADE_EXECUTE(data);

      if (Response.status) {
        Swal.fire({
          icon: "success",
          title: "Trade Executed",
          text: Response.message || "Your trade has been executed successfully.",
          toast: true,
          position: "top-end",
          background: "#1e1e1e",
          color: "#fff",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          iconColor: "#4caf50",
        });

        setRefresh(!refresh);

        if (merketType === "MARKET") {
          setQuantity(100);
          setStopLoss("");
          setTakeProfit("");
        }
      } else {
        throw new Error(Response.message || "Failed to execute trade");
      }
    } catch (error) {
      await Swal.fire({
        title: "Trade Execution Failed",
        text: error.message || "An error occurred while executing the trade. Please try again.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setIsExecuting(false);
      setLoadingStates((prev) => ({ ...prev, executing: false }));
    }
  };

  // ✅ Memoized select options
  const options = useMemo(
    () => filteredSymbols?.map((s) => ({ value: s.name, label: s.name })) || [],
    [filteredSymbols]
  );

  // ✅ Memoized handlers
  const handleSymbolChange = useCallback((selectedOption) => {
    setSelectedSymbol(selectedOption?.value);
    setMarketType("MARKET");
    setIsInitialLoad(true);
    setGetPriceData(null);
  }, []);

  const handleOrderTypeChange = useCallback((newType) => {
    setMarketType(newType);
    const numericPrice = Number(price);

    if (newType === "LIMIT") {
      if (orderType === "Long") {
        setLimitPrice(Math.round(numericPrice - numericPrice * 0.005));
      } else {
        setLimitPrice(Math.round(numericPrice + numericPrice * 0.005));
      }
    }

    if (newType === "STOP") {
      if (orderType === "Long") {
        setStopPrice(Math.round(numericPrice + numericPrice * 0.005));
      } else {
        setStopPrice(Math.round(numericPrice - numericPrice * 0.005));
      }
    }

    setStopLoss("");
    setTakeProfit("");
    setErrors((prev) => ({ ...prev, stopLoss: null, takeProfit: null }));
  }, [price, orderType]);

  const handleQuickSetup = useCallback(() => {
    if (orderType === "Long") {
      setStopLoss(price ? Math.floor(parseFloat(price) * 0.99) : "");
      setTakeProfit(price ? Math.floor(parseFloat(price) * 1.01) : "");
    } else {
      setStopLoss(price ? Math.floor(parseFloat(price) * 1.01) : "");
      setTakeProfit(price ? Math.floor(parseFloat(price) * 0.99) : "");
    }
  }, [price, orderType]);

  const handleResetForm = useCallback(() => {
    setQuantity(100);
    setStopLoss("");
    setTakeProfit("");
    setPrice("");
    setErrors({});
  }, []);

  return (
    <Content button_status={false}>
      {errors.general && (
        <ErrorAlert
          error={errors.general}
          onDismiss={() => setErrors((prev) => ({ ...prev, general: null }))}
        />
      )}

      <div className="row">
        {/* Main Trading Form */}
        <div className="col-lg-8 col-xl-9">
          <div className="enhanced-card mb-4">
            <div className="gradient-border"></div>
            <div className="card-body p-2 p-lg-4">
              <div className="d-lg-flex align-items-center justify-content-between mb-4">
                <div className="d-flex align-items-center">
                  <Zap size={24} className="me-3" />
                  <div>
                    <h4 className="mb-0 fw-bold">Trade Execution</h4>
                    <small className="chart-subtitle">Configure and execute your trade</small>
                  </div>
                </div>

                <div className="fs-6 rounded-pill live-badge live-badge1">
                  <div className="d-flex flex-sm-row align-items-md-center justify-content-between stats-section w-100 w-md-auto">
                    <span className="rounded-pill px-2 py-1 d-flex align-items-center mb-2 mb-sm-0 me-sm-2">
                      <span className={`connection-indicator ${socketConnected ? "connected" : "disconnected"} me-1`} />
                      {socketConnected ? (
                        <>
                          <Wifi size={14} className="me-1" />
                          Live Data
                        </>
                      ) : (
                        <>
                          <WifiOff size={14} className="me-1" />
                          Disconnected
                        </>
                      )}
                    </span>

                    <div className="market-stats px-2 py-1 text-sm-start">
                      <span className="price-ticker fw-semibold">
                        {selectedSymbol}: {price || "---"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <form onSubmit={(e) => e.preventDefault()}>
                <div className="row align-items-end">
                  {/* Symbol Selection */}
                  <div className="col-lg-6 col-md-6 col-7">
                    <div className="mb-3">
                      <label className="form-label fw-semibold d-flex align-items-center">Trading Symbol</label>
                      <Select
                        options={options}
                        onChange={handleSymbolChange}
                        onInputChange={setSearchText}
                        inputValue={searchText}
                        isSearchable
                        placeholder="Search symbol"
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderRadius: "10px",
                            borderWidth: "1.5px",
                            fontWeight: "400",
                            boxShadow: state.isFocused ? "0 0 0 0.25rem rgba(102, 126, 234, 0.25)" : "none",
                            transition: "all 0.2s ease",
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 9999,
                            borderRadius: "10px",
                            boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
                            border: "1px solid #dee2e6",
                          }),
                        }}
                      />
                      {errors.symbol && (
                        <div className="text-danger">
                          <AlertTriangle size={14} className="me-1" />
                          {errors.symbol}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Strategy Selection */}
                  <div className="col-lg-6 col-md-6 col-5">
                    <div className="mb-3">
                      <label className="form-label fw-semibold d-flex align-items-center">
                        <Settings size={16} className="me-2" />
                        Strategy
                      </label>
                      <select
                        value={strategy}
                        onChange={(e) => {
                          setStrategy(e.target.value);
                          setErrors((prev) => ({ ...prev, strategy: null }));
                        }}
                        className={`form-select ${errors.strategy ? "is-invalid" : ""}`}
                        disabled={loadingStates.strategies}
                      >
                        <option value="">Choose Strategy</option>

                        {AllStrategy?.data?.map((s) => (
                          <option key={s._id} value={s.strategy_name}>
                            {s.strategy_name}
                          </option>
                        ))}
                      </select>

                      {errors.strategy && (
                        <div className="text-danger">
                          <AlertTriangle size={14} className="me-1" />
                          {errors.strategy}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Order Direction */}
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="mb-3">
                      <label className="form-label fw-semibold d-flex align-items-center">
                        <TrendingUp size={16} className="me-2" />
                        Order Direction
                      </label>
                      <div className="d-flex justify-content-center">
                        <div className="btn-group-toggle w-100 d-flex" style={{ gap: "8px" }}>
                          <button
                            type="button"
                            className={`btn flex-grow-1 ${orderType === "Long" ? "btn-success" : "btn-outline-secondary"}`}
                            onClick={() => setOrderType("Long")}
                          >
                            <TrendingUp size={16} className="me-2" />
                            Buy
                          </button>
                          <button
                            type="button"
                            className={`btn flex-grow-1 ${orderType === "Short" ? "btn-danger" : "btn-outline-secondary"}`}
                            onClick={() => setOrderType("Short")}
                          >
                            <TrendingDown size={16} className="me-2" />
                            Sell
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Order Type */}
                  <div className="col-lg-6 col-md-6 col-6">
                    <div className="mb-3">
                      <label className="form-label fw-semibold d-flex align-items-center">
                        <DollarSign size={16} className="me-2" />
                        Order Type
                      </label>
                      <select
                        value={merketType}
                        onChange={(e) => handleOrderTypeChange(e.target.value)}
                        className="form-select"
                      >
                        <option value="MARKET">Market</option>
                        <option value="LIMIT">Limit</option>
                        <option value="STOP">Stop</option>
                      </select>
                    </div>
                  </div>

                  {/* Limit Price (conditional) */}
                  {merketType === "LIMIT" && (
                    <div className="col-lg-4 col-md-6 col-6">
                      <div className="mb-3">
                        <label className="form-label fw-semibold d-flex align-items-center">
                          <Shield size={16} className="me-2" />
                          Limit Price
                        </label>
                        <input
                          type="number"
                          value={limitPrice}
                          onChange={(e) => {
                            setLimitPrice(e.target.value);
                            setErrors((prev) => ({ ...prev, limitPrice: null }));
                          }}
                          className={`form-control ${errors.limitPrice ? "is-invalid" : ""}`}
                          placeholder="Limit price"
                          min="0"
                          step="0.00001"
                        />
                        {errors.limitPrice && (
                          <div className="text-danger">
                            <AlertTriangle size={14} className="me-1" />
                            {errors.limitPrice}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Stop Price (conditional) */}
                  {merketType === "STOP" && (
                    <div className="col-lg-4 col-md-6 col-6">
                      <div className="mb-3">
                        <label className="form-label fw-semibold d-flex align-items-center">
                          <Shield size={16} className="me-2" />
                          Stop Price
                        </label>
                        <input
                          type="number"
                          value={stopPrice}
                          onChange={(e) => {
                            setStopPrice(e.target.value);
                            setErrors((prev) => ({ ...prev, stopPrice: null }));
                          }}
                          placeholder="Stop price"
                          min="0"
                          step="0.00001"
                          className={`form-control ${errors.stopPrice ? "is-invalid" : ""}`}
                        />
                        {errors.stopPrice && (
                          <div className="text-danger">
                            <AlertTriangle size={14} className="me-1" />
                            {errors.stopPrice}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Stop Loss */}
                  <div className={`col-lg-4 col-md-6 col-6 ${merketType === "MARKET" ? "col-lg-4" : ""}`}>
                    <div className="mb-3">
                      <label className="form-label fw-semibold d-flex align-items-center">
                        <Shield size={16} className="me-2" />
                        Stop Loss
                      </label>
                      <input
                        type="number"
                        value={stopLoss}
                        onChange={(e) => {
                          setStopLoss(e.target.value);
                          setErrors((prev) => ({ ...prev, stopLoss: null }));
                        }}
                        className={`form-control ${errors.stopLoss ? "is-invalid" : ""}`}
                        placeholder="Stop loss price"
                        min="0"
                        step="0.00001"
                      />
                      {errors.stopLoss && (
                        <div className="text-danger">
                          <AlertTriangle size={14} className="me-1" />
                          {errors.stopLoss}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Take Profit */}
                  <div className={`col-lg-4 col-md-6 col-6 ${merketType === "MARKET" ? "col-lg-4" : ""}`}>
                    <div className="mb-3">
                      <label className="form-label fw-semibold d-flex align-items-center">
                        <Target size={16} className="me-2" />
                        Take Profit
                      </label>
                      <input
                        type="number"
                        value={takeProfit}
                        onChange={(e) => {
                          setTakeProfit(e.target.value);
                          setErrors((prev) => ({ ...prev, takeProfit: null }));
                        }}
                        className={`form-control ${errors.takeProfit ? "is-invalid" : ""}`}
                        placeholder="Take profit price"
                        min="0"
                        step="0.00001"
                      />
                      {errors.takeProfit && (
                        <div className="text-danger">
                          <AlertTriangle size={14} className="me-1" />
                          {errors.takeProfit}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="col-12 mt-4">
                    <div className="d-flex flex-md-row gap-3">
                      <button
                        type="button"
                        className="btn trade-button btn-outline-primary shadow-sm rounded-pill responsive-btn flex-fill"
                        onClick={() => setChartShow(!chartShow)}
                      >
                        <span className="d-flex align-items-center justify-content-center fw-bold responsive-text">
                          📊 {chartShow ? "Hide Chart" : "Show Chart"}
                        </span>
                      </button>

                      <button
                        type="button"
                        className={`btn trade-button shadow-sm rounded-pill responsive-btn flex-fill ${orderType === "Long" ? "btn-success" : "btn-danger"
                          }`}
                        onClick={() => create({ symbol: selectedSymbol, orderType })}
                        disabled={!price || isgotodashboard === true || isExecuting || loadingStates.executing}
                      >
                        {loadingStates.executing ? (
                          <span className="d-flex align-items-center justify-content-center fw-semibold responsive-text">
                            ⏳
                            <div className="spinner-border spinner-border-sm ms-2 me-2" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            Executing...
                          </span>
                        ) : (
                          <span className="d-flex align-items-center justify-content-center fw-bold responsive-text">
                            🚀 Execute {orderType}
                          </span>
                        )}
                      </button>
                    </div>

                    {!price && merketType === "LIMIT" && (
                      <div className="alert alert-warning mt-3 py-2 px-3 d-flex align-items-center shadow-sm rounded">
                        ⚠️ <AlertTriangle size={16} className="ms-2 me-2" />
                        <span className="small fw-semibold">Please set a limit price to execute the order</span>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="col-lg-4 col-xl-3">
          {/* Market Data */}
          <div className="enhanced-card mb-4">
            <div className="gradient-border"></div>
            <div className="card-body p-4">
              <div className="d-flex align-items-center mb-3">
                <Activity size={20} className="me-2" />
                <h5 className="mb-0 fw-semibold">Market Data</h5>
              </div>
              <MarketDataDisplay
                getPriceData={getPriceData}
                isInitialLoad={isInitialLoad}
                selectedSymbol={selectedSymbol}
              />
            </div>
          </div>

          {/* Quick Actions */}
          <div className="enhanced-card">
            <div className="gradient-border"></div>
            <div className="card-body p-4">
              <div className="d-flex align-items-center mb-3">
                <Settings size={20} className="me-2" />
                <h5 className="mb-0 fw-semibold">Quick Actions</h5>
              </div>

              <div className="d-grid gap-2">
                <button
                  className="btn btn-outline-primary d-flex align-items-center justify-content-center"
                  onClick={handleResetForm}
                >
                  <RefreshCw size={16} className="me-2" />
                  Reset Form
                </button>

                <button
                  className="btn btn-outline-info d-flex align-items-center justify-content-center"
                  onClick={handleQuickSetup}
                  disabled={!price}
                >
                  <Target size={16} className="me-2" />
                  Quick Setup
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Chart Section */}
      {chartShow && (
        <div className="row mt-4">
          <div className="col-12">
            <div className="enhanced-card position-relative shadow-lg rounded-4 overflow-hidden">
              <div className="gradient-border"></div>
              <div className="card-body card-body1 p-lg-4 p-0">
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <div className="d-flex align-items-center m-2">
                    <BarChart3 size={24} className="me-3 mt-2" />
                    <div>
                      <h4 className="mb-0 fw-semibold mt-2">Price Chart - {selectedSymbol}</h4>
                      <small className="chart-subtitle">Real-time price movements and technical analysis</small>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-3 me-3">
                    {socketConnected ? (
                      <span className="badge bg-success-subtle text-success px-3 py-2 live-badge d-flex align-items-center">
                        <Wifi size={14} className="me-1" />
                        Live Updates
                      </span>
                    ) : (
                      <span className="badge bg-warning-subtle text-warning px-3 py-2 d-flex align-items-center">
                        <WifiOff size={14} className="me-1" />
                        Reconnecting...
                      </span>
                    )}

                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger rounded-pill fw-semibold d-flex align-items-center"
                      onClick={() => setChartShow(false)}
                    >
                      <span className="me-1">❌</span> Close Chart
                    </button>
                  </div>
                </div>

                <div className="position-relative">
                  <Chartdelta
                    symbol={selectedSymbol}
                    onChange={(newPrice) => {
                      if (merketType === "MARKET") {
                        setPrice(newPrice);
                      }
                    }}
                    target={selectRow?.target}
                    sl={selectRow?.stoploss}
                    show_Lines={true}
                  />

                  {!socketConnected && (
                    <div className="position-absolute top-50 start-50 translate-middle">
                      <div className="text-center">
                        <div className="spinner-border text-primary mb-2" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <p>Connecting to market data...</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Positions Table */}
      <div className="row mt-4">
        <div className="col-12">
          <div className="enhanced-card">
            <div className="gradient-border"></div>
            <div className="card-body p-lg-4 p-0">
              <div className="d-flex align-items-center justify-content-between mb-4">
                <div className="d-flex align-items-center">
                  <PieChart size={24} className="me-3" />
                  <div>
                    <h4 className="mb-0 fw-semibold">Open Positions</h4>
                    <small>Monitor and manage your active trades</small>
                  </div>
                </div>
              </div>

              <PositionModal change={refresh} onChange={setSelectRow} />
            </div>
          </div>
        </div>
      </div>
    </Content>
  );
}

export default Trade;